import React from 'react';

import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import { FormInputCheckbox, FormTextarea } from "../../../ReactHookForm/FormComponents";

const HookSubFormNEETBursary = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    return (
        <FieldsetContainer title='Preparing for Employment' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Does the young person have an up-to-date C.V.?' sectionName={sectionName} name={'has_cv'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormTextarea readOnly={readOnly} label='Comments' sectionName={sectionName} name={'cv_comments'} register={register}
                                  required={false}
                                  maxLength={1000} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>
            { /* <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Does the young person have an up to date skills analysis form?' sectionName={sectionName} name={'has_skills'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormTextarea readOnly={readOnly} label='Comments' sectionName={sectionName} name={'neet_comments'} register={register}
                                  required={false}
                                  maxLength={1000} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>
             */ }
        </FieldsetContainer>
    )
}


export default HookSubFormNEETBursary;
